export function range (start, end) {
  const length = end - start + 1;

  return Array.from({ length }, (_, i) => start + i);
}

export function objectToQueryString (obj) {
  return ['?', Object.entries(obj).map(pair => pair.join('=')).join('&')].join('');
}

export function freeze (time) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  })
}

export const pipe = (...fns) => x => fns.reduce((y, f) => f(y), x);

export function intersection (a1, a2, eq = (a, b) => a === b) {
  return a1.filter(e1 => a2.some(e2 => eq(e1, e2)));
}
